export const price = ({ edition, market = process.env.NEXT_PUBLIC_LNG ?? "de", product, }) => {
    const locales = [market].map((locale) => locale.toLowerCase());
    if (market === "en")
        locales.push("gb");
    const safeEdition = edition ?? product.edition;
    const price = (product.prices ?? []).find(({ market }) => locales.includes(market.toLowerCase()));
    if (!price)
        throw new Error(`No price found for market ${market} and edition ${safeEdition}.`);
    return {
        amount: price[safeEdition],
        currency: price.currency,
    };
};
export const makeCurrencyFormatter = ({ currency, locale, }) => {
    const formatter = new Intl.NumberFormat(locale ?? process.env.NEXT_PUBLIC_LNG ?? "de", {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return (price = 0) => {
        const value = typeof price === "number" ? price : parseFloat(price);
        return formatter.format(value);
    };
};
export const getMinMaxPlayers = ({ playerConfigs, }) => {
    const minPlayers = (playerConfigs?.[0]?.female ?? 0) + (playerConfigs?.[0]?.male ?? 0);
    const maxPlayers = (playerConfigs?.[playerConfigs.length - 1]?.female ?? 0) +
        (playerConfigs?.[playerConfigs.length - 1]?.male ?? 0);
    return { minPlayers, maxPlayers };
};
//# sourceMappingURL=utils.js.map